export interface PageTitleProps {
  title: string;
}

export function PageTitle({ title }: PageTitleProps) {
  return (
    <h1 className="mx-0 mt-0 mb-3 text-primary max-sm:bolt-font-heading-xs-accent sm:bolt-font-heading-m-accent">
      {title}
    </h1>
  );
}
